import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { CartProvider } from "./pages/customer/components/CartContext";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import Home from "./pages/customer/Home";
import Cart from "./pages/customer/Cart";
import Orders from "./pages/customer/Orders";
import Offers from "./pages/customer/Offers";
import Wishlist from "./pages/customer/Wishlist";
import Support from "./pages/customer/Support";
import NotificationsPage from "./pages/customer/NotificationsPage";
import Settings from "./pages/customer/Settings";
import About from "./pages/customer/About";
import Team from "./pages/customer/Team";
import Terms from "./pages/customer/Terms";
import Privacy from "./pages/customer/Privacy";
import Refund from "./pages/customer/Refund";
import Cookie from "./pages/customer/Cookie";
import Partner from "./pages/customer/Partner";
import AdminDashboard from "./pages/admin/Dashboard";
import { getStorageJSON } from "./utils/helpers";

function AppRoutes() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const sessionUser = getStorageJSON("user", null);

  const protectedPage = (element) => (sessionUser ? element : <Navigate to="/login" replace />);
  const adminPage = (element) =>
    sessionUser?.role === "admin" ? element : <Navigate to="/login" replace />;

  useEffect(() => {
    const user = getStorageJSON("user", null);

    // 🌙 AUTO DARK MODE
    const hour = new Date().getHours();
    document.body.classList.toggle("dark", hour >= 18 || hour < 6);

    // 🔥 PREVENT LOOP
    if (location.pathname === "/") {
      if (user) {
        navigate(user.role === "admin" ? "/admin-dashboard" : "/home");
      }
    }

    setLoading(false);
  }, [navigate, location.pathname]);

  if (loading) return <div className="loader">Loading...</div>;

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/Login" element={<Navigate to="/login" replace />} />
      <Route path="/register" element={<Register />} />
      <Route path="/home" element={protectedPage(<Home />)} />
      <Route path="/cart" element={protectedPage(<Cart />)} />
      <Route path="/orders" element={protectedPage(<Orders />)} />
      <Route path="/my-orders" element={protectedPage(<Orders />)} />
      <Route path="/my-order" element={protectedPage(<Navigate to="/my-orders" replace />)} />
      <Route path="/offers" element={protectedPage(<Offers />)} />
      <Route path="/wishlist" element={protectedPage(<Wishlist />)} />
      <Route path="/wish-list" element={protectedPage(<Navigate to="/wishlist" replace />)} />
      <Route path="/support" element={protectedPage(<Support />)} />
      <Route path="/notifications" element={protectedPage(<NotificationsPage />)} />
      <Route path="/notification" element={protectedPage(<Navigate to="/notifications" replace />)} />
      <Route path="/settings" element={protectedPage(<Settings />)} />
      <Route path="/setting" element={protectedPage(<Navigate to="/settings" replace />)} />
      <Route path="/about" element={protectedPage(<About />)} />
      <Route path="/team" element={protectedPage(<Team />)} />
      <Route path="/terms" element={protectedPage(<Terms />)} />
      <Route path="/privacy" element={protectedPage(<Privacy />)} />
      <Route path="/cookie" element={protectedPage(<Cookie />)} />
      <Route path="/cookies" element={protectedPage(<Navigate to="/cookie" replace />)} />
      <Route path="/refund" element={protectedPage(<Refund />)} />
      <Route path="/partner" element={protectedPage(<Partner />)} />
      <Route path="/admin-dashboard" element={adminPage(<AdminDashboard />)} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <AppRoutes />
      </CartProvider>
    </BrowserRouter>
  );
}